import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useMemo } from "react";

const DIGITAL_ATTITUDE_COMPANY_ID = "5706867a-c563-4ca5-b803-c1883c38b640";

/*const TemplateFamilySelect = (props) => (
  <TextField
    fullWidth
    select
    InputLabelProps={{ shrink: true }}
    label={props.label || "Template family select"}
    variant="outlined"
    {...props}
  >
    {props.templatefamilies.map((obj) => {
      return (
        <MenuItem key={obj.tFamilyId} value={obj.tFamilyId}>
          {obj.tFamilyName}
        </MenuItem>
      );
    })}
  </TextField>
);*/

const TemplateFamilySelect = (props) => {
  const { userCompanies, ...otherProps } = props;

  const filteredFamilies = useMemo(() => {
    return props.templatefamilies.filter((template) => {
      if (userCompanies.includes(DIGITAL_ATTITUDE_COMPANY_ID)) return true;
      if (
        !template.whitelistCompany ||
        !Array.isArray(template.whitelistCompany) ||
        template.whitelistCompany.length === 0
      )
        return true;
      for (const companyId of template.whitelistCompany) {
        if (userCompanies.includes(companyId)) return true;
      }
      return false;
    });
  }, [userCompanies, props.templatefamilies]);

  return (
    <TextField
      fullWidth
      select
      InputLabelProps={{ shrink: true }}
      label={props.label || "Template family select"}
      variant="outlined"
      {...otherProps}
    >
      {filteredFamilies.map((obj) => {
        return (
          <MenuItem key={obj.tFamilyId} value={obj.tFamilyId}>
            {obj.tFamilyName}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default TemplateFamilySelect;
